'use strict';

angular.module('domain.advancedSearch').controller('AdvancedSearchOpportunity', [
	'AppService',
	'$scope',
	'$stateParams',
	function (AppService, $scope, $stateParams) {
		var AdvancedSearchOpportunity = this;
		var AdvancedSearch = $scope.AdvancedSearch;

		var init = function () {
			AdvancedSearch.changeSearchType(AdvancedSearch.entity.OPPORTUNITY, $stateParams.notificationEntityId);

			AdvancedSearch.loaded = true;
		};

		AppService.loadedPromise.then(init);
	}
]);
